import React, { useEffect, useState } from "react";
import { Container, Row, Button } from "react-bootstrap";
import useCustomGetStoreState from "../../hooks/useCustomGetStoreState.jsx";
import useBackButton from "../../hooks/useBackButton.jsx";
import DownloadRomeVideosPDF from "../../components/widgets/generatePDFs/romesVideosList.jsx";
import RomesPageContent from "./RomesPageContent.jsx";
import { useStoreActions } from "easy-peasy";
import AuthorizationChecker from "../../services/AuthorizationChecker.js";

const RomesPage = () => {
    const { allVideos, isFetchingAllVideos } = useCustomGetStoreState("videos");
    const { allStories, isFetchingAllStories } = useCustomGetStoreState("stories");
    const { allRomes, isFetchingAllRomes } = useCustomGetStoreState("romes");
    const { fetchAllRomesSubProps } = useStoreActions(actions => actions.romes);
    const { backButtonComponent } = useBackButton();
    const btnPdfRomesLabel = "Pdf expériences immersives par codes ROME";
    const [generateJobs, setGenerateJobs] = useState(false);
    const [romesWithVideosAndStoriesCount, setRomesWithVideosAndStoriesCount] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!allRomes || allRomes.length === 0) return;
        fetchAllRomesSubProps();
    }, [allRomes]);

    useEffect(() => {
        if (allRomes?.length > 0 && allVideos?.length > 0 && allStories?.length > 0) {
            const updatedRomes = allRomes.map(rome => {
                const videoCount = allVideos.filter(video => video.romes.includes(rome.codeRome
                )).length;
                const storiesCount = allStories.filter(story => story.romes.includes(rome.codeRome)).length;
                return { ...rome, ...{ usageStories: storiesCount, usageVideos: videoCount } };
            });
            setRomesWithVideosAndStoriesCount(updatedRomes);
        }
        setIsLoading(isFetchingAllVideos || isFetchingAllStories || isFetchingAllRomes);
    }, [allRomes, allVideos, allStories, isFetchingAllRomes, isFetchingAllVideos, isFetchingAllStories]);

    return (
        <Container fluid>
            <Row className="item-page">
                <h2 className="d-flex justify-content-between">
                    Codes ROME
                    {AuthorizationChecker.isPageAccesibleFromMenu('romesHome') && backButtonComponent}
                </h2>
            </Row>
            <Row className="mb-3 justify-content-between align-items-center">
                <div className="p-0 w-auto">
                    {generateJobs
                        ? <DownloadRomeVideosPDF romes={romesWithVideosAndStoriesCount} videos={allVideos} btnPdfLabel={btnPdfRomesLabel} />
                        : <Button variant="primary" onClick={() => { setGenerateJobs(true) }}
                            disabled={allRomes?.length === 0 || allVideos?.length === 0}>
                            <i className="fas fa-download mr-1" />{btnPdfRomesLabel}
                        </Button>}
                </div>
            </Row>
            <RomesPageContent
                romes={romesWithVideosAndStoriesCount?.length > 0 ? romesWithVideosAndStoriesCount : allRomes}
                isFetching={isLoading}
            />
        </Container>
    )
}

export default RomesPage;